import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import { CustomerContacts } from './models/CustomerInterfaces';
import ConfirmPopups from './ConfirmPopup';

interface CustomerProps {
    id: number;
    readOnly: boolean;
    accountContactName: string;
    accountContactPhone: string;
    accountContactEmail: string;
    customerContacts: CustomerContacts[];
    errors: { [key: string]: string };
    updateContacts(customerContacts: CustomerContacts[]): void;
}

const CustomerContact = (props: CustomerProps) => {
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [modalSaveDisabled, setModalSaveDisabled] = React.useState(false);
    const [contactIndex, setContactIndex] = React.useState(-1);

    const copyAccountContact = (e: any) => {
        e.preventDefault();

        let spaceIndex = props.accountContactName.indexOf(" ");
        let firstName = spaceIndex < 1 ? props.accountContactName : props.accountContactName.substring(0, spaceIndex);
        let lastStartIndex = spaceIndex + 1;
        let endIndex = props.accountContactName.length;
        let lastName = spaceIndex < 1 || endIndex < 1 ? "" : props.accountContactName.substring(lastStartIndex, endIndex);
        let mobile = props.accountContactPhone.startsWith("04") ? props.accountContactPhone : "";
        let phone = props.accountContactPhone.startsWith("04") ? "" : props.accountContactPhone;

        var newContact: CustomerContacts = {
            id: 0,
            email: props.accountContactEmail,
            firstName: firstName,
            lastName: lastName,
            mobile: mobile,
            phone: phone,
            emailSubscription: true,
            statusId: 1
        };

        var custContacts = [...props.customerContacts];
        custContacts.splice(0, 0, newContact);
        props.updateContacts(custContacts);
    }

    const onCellChange = (itemIndex: number, item: string, value: any) => {
        //update item that has changed
        var customerContacts = [...props.customerContacts];
        var customerContact = customerContacts[itemIndex];
        let newcustomerContact: any = {};
        newcustomerContact = customerContact;
        newcustomerContact[item] = value;

        //if last row then add a new row
        if (itemIndex == customerContacts.length - 1) {
            var custContact: CustomerContacts = {
                id: 0,
                firstName: "",
                lastName: "",
                phone: "",
                mobile: "",
                email: "",
                emailSubscription: true,
                statusId: 1
            };
            customerContacts.push(custContact);
        }

        props.updateContacts(customerContacts);
    }

    const onCellCheckboxChange = (itemIndex: number, e: any) => {
        var customerContacts = [...props.customerContacts];
        var customerContact = customerContacts[itemIndex];

        let newcustomerContact: any = {};
        newcustomerContact = customerContact;
        newcustomerContact[e.target.name] = e.target.checked;

        props.updateContacts(customerContacts);
    }
    
    //DELETE CONTACT
    const deleteContact = (e: any, index: number) => {
        e.preventDefault();

        setModalSaveDisabled(false);
        setShowConfirm(true);
        setContactIndex(index);
    }

    const hideConfirmModal = () => {
        setModalSaveDisabled(false);
        setShowConfirm(false);
        setContactIndex(-1);
    }

    const saveConfirmModal = () => {
        if (modalSaveDisabled) {
            return;
        }
        setModalSaveDisabled(true);

        var contacts = [...props.customerContacts];
        var contact = contacts[contactIndex];

        if (contact.id == 0) {
            //just delete from the grid as doesn't exist in the database
            toast.success("Contact has been deleted");
            contacts.splice(contactIndex, 1);
            props.updateContacts(contacts);

            setModalSaveDisabled(false);
            setShowConfirm(false);
            setContactIndex(-1);
        } else {
            saveDeleteContact();
        }
    }

    const saveDeleteContact = async () => {
        const token = await authService.getAccessToken();

        var contacts = [...props.customerContacts];
        var contact = contacts[contactIndex];
        var deleteContact = {
            id: contact.id
        };

        axios.post('api/Customer/DeleteContact', deleteContact, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Contact has been deleted");
                contacts.splice(contactIndex, 1);
                props.updateContacts(contacts);

                setModalSaveDisabled(false);
                setShowConfirm(false);
                setContactIndex(-1);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END DELETE CONTACT

    var lastRowIndex = props.customerContacts.length - 1;
    let confirmDelete = <ConfirmPopups heading="Delete Contact" text="Delete customer contact?" showConfirmModal={showConfirm} hideConfirmModal={hideConfirmModal} saveConfirmModal={saveConfirmModal} />
    
    const renderDetails = (
        <div>
            <div className="static-modal">
                {confirmDelete}
            </div>
            <div>Enter any job contacts who will receive the email confirmation and job updates. ONLY enter the Account contact here if they will be the email contact person for job updates.</div>
            <div className={props.id === 0 ? "" : "hidden"}>
                <a href="#" onClick={(e) => copyAccountContact(e)}>Add Account Contact</a>
            </div>
            <div className="table__margin overflowAuto">
                <table className="table table__large tableColours">
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th></th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Phone</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>
                                <div className="tooltipitem tooltipitem__left">Email Updates?
                                    <span className="tooltipitemtext tooltipitemtext__left">Tick if customer is happy to receive weekly job updates</span>
                                </div>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.customerContacts.map((customer, index) =>
                            <tr key={index}>
                                <td className="hidden">{customer.id}</td>
                                <td className="table__text--align">{index + 1}</td>
                                <td className="table__text--align">
                                    <input type="text" className={props.readOnly ? "hidden" : "form-control"} id="firstName" value={customer.firstName} onChange={(e) => onCellChange(index, "firstName", e.target.value)} />
                                    {props.readOnly ? customer.firstName : ""}
                                </td>
                                <td className="table__text--align">
                                    <input type="text" className={props.readOnly ? "hidden" : "form-control"} id="lastName" value={customer.lastName} onChange={(e) => onCellChange(index, "lastName", e.target.value)} />
                                    {props.readOnly ? customer.lastName : ""}
                                </td>
                                <td className="table__text--align">
                                    <input type="text" className={props.readOnly ? "hidden" : "form-control"} id="phone" value={customer.phone} onChange={(e) => onCellChange(index, "phone", e.target.value)} />
                                    {props.readOnly ? customer.phone : ""}
                                </td>
                                <td className="table__text--align">
                                    <input type="text" className={props.readOnly ? "hidden" : "form-control"} id="mobile" value={customer.mobile} onChange={(e) => onCellChange(index, "mobile", e.target.value)} />
                                    {props.readOnly ? customer.mobile : ""}
                                </td>
                                <td className="table__text--align">
                                    <input type="text" className={props.readOnly ? "hidden" : "form-control"} id="email" value={customer.email} onChange={(e) => onCellChange(index, "email", e.target.value)} />
                                    {props.readOnly ? customer.email : ""}
                                </td>
                                <td className="table__text--align">
                                    <input type='checkbox' className="alignIconCenter" id="emailSubscription" name="emailSubscription" checked={customer.emailSubscription} onClick={(e) => onCellCheckboxChange(index, e)} disabled={props.readOnly} />
                                </td>
                                <td className="table__text--align">
                                    <div className={lastRowIndex != index && !props.readOnly ? "delete--tablecell" : "hidden"}>
                                        <a className="makeitred" href="#" onClick={(e) => deleteContact(e, index)}>
                                            <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {props.errors["contacts"] ?
                    (props.errors["contacts"]).split("\n").map((item: any, key: any) => {
                        return <span className="label errors" key={key}>{item}<br /></span>
                    })
                    : ""}
            </div>
        </div>
    );

    return (
        <div>
            {renderDetails}
        </div>
    );

}

export default CustomerContact;